import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addEmployerLogo } from "./EmployerLogoAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const addEmployerLogoAsync = createAsyncThunk(
  "employerLogo/upload",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const result = await addEmployerLogo(formData); 
      return result; 
    } catch (error) {
      return rejectWithValue(error.message); // If error occurs, return the error message
    }
  }
);

const EmployerLogoSlice = createSlice({
  name: "EmployerLogo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(addEmployerLogoAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addEmployerLogoAsync.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});
export const selectEmployerLogo = (state) => state.employerLogo.data;

export default EmployerLogoSlice.reducer;
